import { useState, useEffect, useCallback, useMemo } from 'react';

const useFetch = (url, options = {}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const memoizedOptions = useMemo(() => options, [JSON.stringify(options)]);

  const fetchData = useCallback(
    async (signal) => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(url, {
          ...memoizedOptions,
          signal,
          headers: { 'Cache-Control': 'no-cache', ...memoizedOptions.headers },
        });
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          setError(
            new Error(
              errorData.error || `HTTP Error! Status: ${response.status}`
            )
          );
          return;
        }
        const responseData = await response.json();
        setData(responseData);
      } catch (err) {
        if (err.name !== 'AbortError') {
          setError(err);
        }
      } finally {
        setLoading(false);
      }
    },
    [url, memoizedOptions]
  );

  useEffect(() => {
    const controller = new AbortController();
    fetchData(controller.signal);
    return () => controller.abort();
  }, [fetchData]);

  return { data, loading, error, refresh: fetchData };
};

export default useFetch;
